module.exports = __webpack_public_path__ + "static/media/chocolate-box-gold.f07fbf2d.jpg";